import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=c66aff90"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c66aff90')) {
      api.createRecord('c66aff90', component.options)
    } else {
      api.reload('c66aff90', component.options)
    }
    module.hot.accept("./Information.vue?vue&type=template&id=c66aff90", function () {
      api.rerender('c66aff90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Information.vue"
export default component.exports